<template>
  <div class="py-4">
    <CommonDataTable :keySearch="keySearch" />
  </div>
</template>
<script>
import CommonDataTable from "../../../screens/adminScreen/common/CommonDataTable";
export default {
  data() {
    return { keySearch: "" };
  },
  methods: {},
  components: { CommonDataTable },
};
</script>
